import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmountComponent } from './amount.component';

@NgModule({
  imports: [CommonModule],
  declarations: [AmountComponent],
  exports: [AmountComponent]
})
export class AmountModule {}
